import { ComponentConfigurationClass } from "@zoovu/runner-browser-api";
import { AnimationStyleListSelection, TransitionSpeedListSelection, TransitionStyleListSelection, InfoTextAnimationStyleListSelection } from "./common-configuration";
import { ConfigurationValues, ValuesConfigurationConstructor } from "./values";

/**
 * @title Animations & transitions
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.AnimationsAndTransitions)
@ComponentConfigurationClass("animationsAndTransitionsConfiguration")
export class AnimationsAndTransitionsConfiguration {
    /**
     * @title Animate answers on hover and click
     */
    public animationsEnabled?: boolean;

    /**
     * @format custom-list
     */
    public animationStyle?: AnimationStyleListSelection;

    /**
     * @title Show transition between questions
     */
    public transitionsEnabled?: boolean;

    /**
     * @format custom-list
     */
    public transitionStyle?: TransitionStyleListSelection;

    /**
     * @format custom-list
     */
    public transitionSpeed?: TransitionSpeedListSelection;

    /**
     * @title Show tooltips animated
     */
    public infoTextAnimationsEnabled?: boolean;

    /**
     * @format custom-list
     */
    public infoTextAnimationStyle?: InfoTextAnimationStyleListSelection;
}
